
const PeerMentorNetworkData = [
    {
        id: 1,
        bannerImg: require("../../../Assets/Gulf_Students/Peer_Mentorship/1-on-1-mentor.png"),
        text: "1-on-1 mentor matching by field and destination"
    },
    {
        id: 2,
        bannerImg: require("../../../Assets/Gulf_Students/Peer_Mentorship/Monthly-virtual.png"),
        text: "Monthly virtual meetups and Q&A sessions"
    },
    {
        id: 3,
        bannerImg: require("../../../Assets/Gulf_Students/Peer_Mentorship/Access-to-private.png"),
        text: "Access to private WhatsApp community"
    },
    {
        id: 4,
        bannerImg: require("../../../Assets/Gulf_Students/Peer_Mentorship/Optional-alumni.png"),
        text: "Optional alumni spotlight events"
    }
];

export default PeerMentorNetworkData;